/** Регистрация service worker (public/sw.js) — для приложения в Google Play
 *  (Trusted Web Activity) и установки PWA. Воркер игру не кеширует, только
 *  показывает offline.html, когда нет сети. Подключается отдельным модулем из
 *  index.html, чтобы не трогать main.ts.
 *
 *  Только в боевой сборке: на vite-сервере и в тестовых стендах воркер не нужен
 *  (меньше сюрпризов с кешем между прогонами). ?nosw=1 — снять регистрацию
 *  руками, если воркер мешает при отладке на телефоне. */
export {};

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const off = new URLSearchParams(location.search).get("nosw") === "1";
  window.addEventListener("load", () => {
    if (off) {
      void navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => void r.unregister()));
      return;
    }
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((e) => {
      console.warn("[pwa] service worker не зарегистрирован:", e);
    });
  });
}
